import {Modal as BootstrapModal, ModalFooter, ModalBody, ModalHeader} from 'reactstrap'

import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Modal from '../../../../shared/components//Modals/Modal.jsx'

export default class DeleteDiplomeModal extends Modal {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  handleDelete = async (values) => {
    const {freelance} = this.props
    const diplomes = [...(this.props.freelance?.diplomes || [])]
    diplomes.splice(this.props.offset, 1)
    this.setState({ loading: true })

    try {
      this.props.onSubmit({
        freelance: {...freelance, diplomes: diplomes}
      })
    } finally {
      this.setState({ loading: false })
      this.props.closeModal()
    }
  }

  render() {
    if (!this.props.freelance) {
      return null
    }

    const diplome = (this.props.offset !== undefined && this.props.freelance.diplomes[this.props.offset]) || null

    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} className="mission-modal modal-lg">
        <ModalHeader toggle={this.props.closeModal}>Suppression</ModalHeader>
        <ModalBody>
          <div className="text-center">
            Vous êtes sur le point de supprimer votre diplôme / formation
            {diplome && <b>&nbsp;{diplome.name}</b>}.
            Cette action est irreversible.
          </div>
          <Loader visible={this.state.loading}>
            Suppression...
          </Loader>
        </ModalBody>
        <ModalFooter>
          <button onClick={this.props.closeModal} type="button" className="btn btn-outline-shy">Annuler</button>
          <button onClick={this.handleDelete} type="button" className="ml-auto btn btn-danger">Supprimer</button>
        </ModalFooter>
      </BootstrapModal>
    )
  }
}
